import { userType } from './user/user.constants';
const ɵ0 = () => import("./public/public.module.ngfactory").then(m => m.PublicModuleNgFactory), ɵ1 = {
    rolesAllowed: [userType.applicant.code]
}, ɵ2 = () => import("./applicant/applicant.module.ngfactory").then(m => m.ApplicantModuleNgFactory), ɵ3 = {
    rolesAllowed: [userType.assessor.code]
}, ɵ4 = () => import("./assessor/assessor.module.ngfactory").then(m => m.AssessorModuleNgFactory), ɵ5 = {
    rolesAllowed: [userType.auditor.code]
}, ɵ6 = () => import("./auditor/auditor.module.ngfactory").then(m => m.AuditorModuleNgFactory), ɵ7 = {
    rolesAllowed: [userType.board.code]
}, ɵ8 = () => import("./board/board.module.ngfactory").then(m => m.BoardModuleNgFactory), ɵ9 = {
    rolesAllowed: [userType.external.code]
}, ɵ10 = () => import("./external/external.module.ngfactory").then(m => m.ExternalModuleNgFactory), ɵ11 = () => import("./guest/guest.module.ngfactory").then(m => m.GuestModuleNgFactory), ɵ12 = {
    rolesAllowed: [userType.management.code]
}, ɵ13 = () => import("./management/management.module.ngfactory").then(m => m.ManagementModuleNgFactory);
export class AppModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13 };
